import {
    REMOVE_GOOGLE_RECAPTCHA_TOKEN,
    SET_CAPTCHA_SERVICE,
    SET_GOOGLE_RECAPTCHA_TOKEN,
    SET_SIMPLE_CAPTCHA,
    RESET_CAPTCHA_CONFIG
} from "@/core/store/modules/captcha/constants";

export default {
    [SET_GOOGLE_RECAPTCHA_TOKEN](state, token) {
        state.googleRecaptchaToken = token;
    },
    [REMOVE_GOOGLE_RECAPTCHA_TOKEN](state) {
        state.googleRecaptchaToken = null;
    },

    [SET_CAPTCHA_SERVICE](state, data) {
        state.type = data.type
        state.is_active = data.is_active
        state.action = data.action
        state.limit = data.limit
        if (['recaptcha', 'hcaptcha'].includes(data.type)) {
            state.site_key = data.site_key
        }

        if (data.type === 'simple') {
            state.api = data.api
        }

    },

    [SET_SIMPLE_CAPTCHA](state, data) {
        state.image = data.img
        state.captcha_key = data.key
    },
    [RESET_CAPTCHA_CONFIG](state) {
        state.action = null
        state.is_active = null
        state.type = null
        state.googleRecaptchaToken = null
        state.api = null
        state.captcha_key = null
        state.image = null
        state.site_key = null
    }
}